import React, { Fragment } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Redirect
} from 'react-router-dom';
import { ThemeProvider, injectGlobal } from 'styled-components';
import MessengerCustomerChat from 'react-messenger-customer-chat';

import NavBar from './components/NavBar';
import HomePage from './components/HomePage';
import SubPage from './components/SubPage';
import SubscribeWidget from './components/SubscribeWidget';
import Footer from './components/Footer';

import hiringSource from './assets/markdown/hiring.md';
import termsSource from './assets/markdown/terms.md';
import privacySource from './assets/markdown/privacy.md';

import regularFont from './assets/fonts/DMSans-Regular.ttf';
import boldFont from './assets/fonts/DMSans-Medium.ttf';
import thinFont from './assets/fonts/DMSans-Regular.ttf';

const mobileBreakPoint = '600px';
const tabletBreakPoint = '900px';

injectGlobal`
	@font-face {
		font-family: DMSans;
		src: url(${regularFont});
		font-weight: normal;
    	font-style: normal;
	}
	@font-face {
		font-family: DMSans;
		src: url(${boldFont});
		font-weight: bold;
	}
	@font-face {
		font-family: DMSans;
		src: url(${thinFont});
		font-weight: light;
	}

	:root {
		/*dimensions*/
		--side-margin: 10vw;
		/*colors*/
		--purple: #9900ff;
		--purple-light: #b352be;
		--orange: #FF9C46;
		--orange-light: #FFE8DB;
		--red: #ff0018;
		--blue: #3366ff;
		--green: #66eeaa;
		--cyan: #00ddff;
		--primary-gradient: linear-gradient(
			to right bottom,
			#FFFFFF,
			#FFFFFF

		);
		/*font sizes*/
		--fs-x-big: 3rem;
		--fs-big: 1.5rem;
		--fs-medium: 1.1rem;
		--fs-small: 0.9rem;
		--fs-x-small: 0.7rem;
	}

	@media screen and (max-width: ${tabletBreakPoint}) {
		:root {
			--side-margin: 7vw;
			--fs-x-big: 1.8rem;
		}
	}

	@media screen and (max-width: ${mobileBreakPoint}) {
		:root {
			--side-margin: 5vw;
			--fs-x-big: 1.6rem;
			--fs-big: 1.3rem;
			--fs-medium: 1rem;
			--fs-small: 0.8rem;
			--fs-x-small: 0.65rem;
		}
	}

	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	body {
		margin: 0;
  		padding: 0;
		font-family: DMSans, "Helvetica Neue", Helvetica, "Segoe UI", Arial, sans-serif;
		background-color: #FFE8DB;
	}
`;

const theme = {
	tabletBreakPoint,
	mobileBreakPoint
};

const App = () => {
	return (
		<Router>
			<ThemeProvider theme={theme}>
				<Fragment>
					<Route path="/" component={NavBar} />
					<Switch>
						<Route path="/" component={HomePage} exact />
						<Route
							path="/join-us"
							render={() => <SubPage heading="Join us" text={hiringSource} />}
						/>
						<Route
							path="/privacy.html"
							render={() => (
								<SubPage heading="Privacy Policy" text={privacySource} />
							)}
						/>
						<Route
							path="/terms.html"
							render={() => (
								<SubPage heading="Terms of Service" text={termsSource} />
							)}
						/>
						<Redirect to="/" />
					</Switch>
					<SubscribeWidget />
					<Footer terms={termsSource} privacy={privacySource} />
					<MessengerCustomerChat
						pageId="1920110698250515"
						appId="1961923350733593"
						themeColor="#FF9C46"
						loggedInGreeting="Hi! We're glad to have you here today! How can we help you?"
						loggedOutGreeting="Hi! We're glad to have you here today! How can we help you?"
					/>
				</Fragment>
			</ThemeProvider>
		</Router>
	);
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js